import axios from "axios";

const store = {
  state: {
    notes: [],
  },

  getters: {
    getNotes(state) {
      return state.notes;
    },
  },

  mutations: {
    loadNotesMutation(state, notes) {
      state.notes = notes;
    },

    addNoteMutation(state, note) {
      state.notes.push(note);
    },

    setNoteMutation(state, note) {
      let index = state.notes.findIndex((c) => c.id == note.id);
      if (!note.change_category) state.notes.splice(index, 1, note);
      else state.notes.splice(index, 1);
    },

    deleteNoteMutation(state, noteId) {
      let index = state.notes.findIndex((c) => c.id == noteId);
      state.notes.splice(index, 1);
    },

    clearNotes(state) {
      state.notes = [];
    },
  },

  actions: {
    storeNoteAction({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/note/store`, payload)
          .then((res) => {
            commit("addNoteMutation", res.data.note);
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    findNotesByCategoryAction({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/note/find-by-category`, payload)
          .then((res) => {
            commit("loadNotesMutation", res.data);
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    showNoteAction(Context, noteId) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/note/${noteId}`)
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    updateNoteAction({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/note/update/${payload.id}`, payload)
          .then((res) => {
            commit("setNoteMutation", res.data.noteResult);
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    deleteNoteAction({ commit }, noteId) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/note/delete/${noteId}`)
          .then(() => {
            commit("deleteNoteMutation", noteId);
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};

export default store;
